import { React, useEffect } from 'react';
import Nav from './Nav2';
import './option.css';
import logo from './img/gap.png';

function Option() {
  return (
    <div>
        <div className="option">
            <Nav/>
            <div className='choose-box'>
                <img src={logo} alt="GAP Logo" width={250} style={{marginBottom: -35}}/>
                <h4>Veuillez vous connecter </h4>
                <hr/>
                <a href='Student'><button className='choose-btn'>Se connecter comme Etudiant</button></a>
                <br/>
                <a href='login'><button className='choose-btn' id='last-btn'>Se connecter comme Personnel</button></a>
            </div>
        </div>
            <footer id='footer'> <br/> G.A.P 2024 © All Rights Reserved. <br/> <br/> </footer>
    </div>
  );
}

export default Option;
